<template>
  <div class="container">

    <nav class="navbar navbar-expand-lg navbar-dark">
      <router-link to="/" class="navbar-brand">
        <img src="@/assets/nav_logo.png"  height="35" alt="logo image">
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <router-link to="/" class="nav-link"> </router-link>
        </div>
      </div>
    </nav>

    <!-- THE ACTUAL CONTENT -->
    <router-view />

  </div>
</template>

<script>
// import 'bootstrap/dist/js/bootstrap.js'

</script>


